// src/auto-complete-form/index.tsx
import { AutoComplete } from "@oppy/omniv2-ui";
import {
  Controller
} from "react-hook-form";
import { jsx } from "react/jsx-runtime";
function AutoCompleteForm({
  control,
  completeMethod,
  field,
  name,
  placeholder,
  suggestions
}) {
  return /* @__PURE__ */ jsx(
    Controller,
    {
      control,
      name,
      render: ({
        field: { onChange, onBlur, value, ref },
        fieldState: { error }
      }) => /* @__PURE__ */ jsx(
        AutoComplete,
        {
          completeMethod,
          field,
          suggestions,
          error: error?.message,
          ref,
          onChange,
          onBlur,
          placeholder,
          value
        }
      )
    }
  );
}

// src/calendar-form/index.tsx
import { Calendar } from "@oppy/omniv2-ui";
import { Controller as Controller2 } from "react-hook-form";
import { jsx as jsx2 } from "react/jsx-runtime";
function InputForm({
  control,
  hourFormat,
  name,
  placeholder,
  showTime
}) {
  return /* @__PURE__ */ jsx2(
    Controller2,
    {
      control,
      name,
      render: ({
        field: { onChange, onBlur, ref, value },
        fieldState: { error }
      }) => /* @__PURE__ */ jsx2(
        Calendar,
        {
          error: error?.message,
          hourFormat,
          onChange,
          onBlur,
          placeholder,
          ref,
          showTime,
          value
        }
      )
    }
  );
}

// src/color-picker-form/index.tsx
import { ColorPicker } from "@oppy/omniv2-ui";
import {
  Controller as Controller3
} from "react-hook-form";
import { jsx as jsx3 } from "react/jsx-runtime";
function ColorPickerForm({
  control,
  name,
  label
}) {
  return /* @__PURE__ */ jsx3(
    Controller3,
    {
      control,
      name,
      render: ({
        field: { onBlur, onChange, value },
        fieldState: { error }
      }) => /* @__PURE__ */ jsx3(
        ColorPicker,
        {
          error: error?.message,
          label,
          value,
          onBlur,
          onChange
        }
      )
    }
  );
}

// src/file-uploader-form/file-uploader-form.tsx
import { FileUploader } from "@oppy/omniv2-ui";
import { Controller as Controller4 } from "react-hook-form";

// src/file-uploader-form/hooks/use-file-uploader-form.ts
import { useMemo } from "react";
function useFileUploaderForm(error) {
  return useMemo(() => {
    const { src, size, name: fileName, extension, message } = error ?? {};
    return size ?? src ?? fileName ?? extension ?? { message };
  }, [error]);
}

// src/file-uploader-form/file-uploader-form.tsx
import { jsx as jsx4 } from "react/jsx-runtime";
var FileUploaderControlled = function({
  error,
  helperText,
  name,
  placeholder,
  value,
  acceptedFiles,
  maxSize,
  onChange
}) {
  const pictureError = useFileUploaderForm(error);
  return /* @__PURE__ */ jsx4(
    FileUploader,
    {
      error: pictureError?.message,
      helperText,
      name,
      placeholder,
      value,
      onChange,
      acceptedFiles,
      maxSize
    }
  );
};
function FileUploaderForm({
  control,
  helperText,
  name,
  placeholder,
  acceptedFiles,
  maxSize
}) {
  return /* @__PURE__ */ jsx4(
    Controller4,
    {
      control,
      name,
      render: ({
        field: { name: fieldName, value, onChange },
        fieldState: { error }
      }) => /* @__PURE__ */ jsx4(
        FileUploaderControlled,
        {
          error,
          name: fieldName,
          placeholder,
          helperText,
          value,
          onChange,
          acceptedFiles,
          maxSize
        }
      )
    }
  );
}

// src/input-form/index.tsx
import { Input } from "@oppy/omniv2-ui";
import { Controller as Controller5 } from "react-hook-form";
import { jsx as jsx5 } from "react/jsx-runtime";
function InputForm2({
  control,
  name,
  placeholder,
  hidden,
  prefix,
  max,
  hasEmojiPicker,
  disabled
}) {
  return /* @__PURE__ */ jsx5(
    Controller5,
    {
      control,
      name,
      render: ({
        field: { onChange, onBlur, ref, value },
        fieldState: { error }
      }) => /* @__PURE__ */ jsx5(
        Input,
        {
          error: error?.message,
          onChange,
          onBlur,
          placeholder,
          ref,
          value,
          hidden,
          prefix,
          helperText: max ? `${value.length || 0} / ${max}` : "",
          max,
          hasEmojiPicker,
          disabled
        }
      )
    }
  );
}

// src/picture-uploader-form/index.tsx
import { PictureUploader } from "@oppy/omniv2-ui";
import { Controller as Controller6, useFormContext } from "react-hook-form";

// src/picture-uploader-form/hooks/use-picture-uploader-form/index.ts
import { useMemo as useMemo2 } from "react";
function usePictureUploaderForm(error) {
  return useMemo2(() => {
    const {
      src,
      size,
      imageType,
      name: imageName,
      message,
      resolution
    } = error ?? {};
    return imageType ?? size ?? src ?? imageName ?? resolution ?? { message };
  }, [error]);
}

// src/picture-uploader-form/index.tsx
import { jsx as jsx6 } from "react/jsx-runtime";
var PictureUploaderControlled = function({
  accept,
  error,
  helperText,
  name,
  placeholder,
  value,
  onChange,
  allowedRatio,
  allowedImageTypes,
  onReject
}) {
  const pictureError = usePictureUploaderForm(error);
  return /* @__PURE__ */ jsx6(
    PictureUploader,
    {
      accept,
      error: pictureError?.message,
      helperText,
      name,
      placeholder,
      value,
      onChange,
      isCroppable: true,
      allowedRatio,
      allowedImageTypes,
      onReject
    }
  );
};
function PictureUploaderForm({
  accept,
  control,
  helperText,
  name,
  placeholder,
  allowedRatio,
  allowedImageTypes
}) {
  const formContext = useFormContext();
  return /* @__PURE__ */ jsx6(
    Controller6,
    {
      control,
      name,
      render: ({
        field: { name: fieldName, value, onChange },
        fieldState: { error }
      }) => {
        const setError = formContext?.setError;
        const clearErrors = formContext?.clearErrors;
        const onReject = allowedImageTypes?.length && setError ? (message) => {
          setError(fieldName, {
            type: "custom",
            message
          });
          onChange(null);
        } : void 0;
        const wrappedOnChange = (newValue) => {
          if (allowedImageTypes?.length && clearErrors && newValue?.imageType && allowedImageTypes.includes(newValue.imageType)) {
            clearErrors(fieldName);
          }
          onChange(newValue);
        };
        return /* @__PURE__ */ jsx6(
          PictureUploaderControlled,
          {
            accept,
            error,
            name: fieldName,
            placeholder,
            helperText,
            value,
            onChange: wrappedOnChange,
            allowedRatio,
            allowedImageTypes,
            onReject
          }
        );
      }
    }
  );
}

// src/radio-button-form/index.tsx
import { RadioButton } from "@oppy/omniv2-ui";
import {
  Controller as Controller7
} from "react-hook-form";
import { jsx as jsx7 } from "react/jsx-runtime";
function RadioButtonForm({
  control,
  name,
  label,
  value,
  inputId,
  onChange
}) {
  return /* @__PURE__ */ jsx7(
    Controller7,
    {
      control,
      name,
      render: ({
        field: { onChange: controllerOnChange, ref, value: fieldValue }
      }) => /* @__PURE__ */ jsx7(
        RadioButton,
        {
          checked: fieldValue === value,
          onChange: (e) => {
            if (e.checked) {
              controllerOnChange(value);
              onChange?.(value);
            }
          },
          label,
          value,
          inputRef: ref,
          id: inputId
        }
      )
    }
  );
}

// src/select-form/index.tsx
import { Select } from "@oppy/omniv2-ui";
import { Controller as Controller8 } from "react-hook-form";
import { jsx as jsx8 } from "react/jsx-runtime";
function SelectForm({
  control,
  name,
  placeholder,
  options,
  onChange,
  optionLabel = "label"
}) {
  return /* @__PURE__ */ jsx8(
    Controller8,
    {
      control,
      name,
      render: ({
        field: { onChange: handleOnChange, value },
        fieldState: { error }
      }) => /* @__PURE__ */ jsx8(
        Select,
        {
          placeholder,
          options,
          value,
          optionLabel,
          onChange: (event) => {
            handleOnChange(event.value);
            onChange?.(event);
          },
          error: error?.message
        }
      )
    }
  );
}

// src/switch-form/index.tsx
import { Switch } from "@oppy/omniv2-ui";
import { Controller as Controller9 } from "react-hook-form";
import { Fragment, jsx as jsx9 } from "react/jsx-runtime";
var SwitchFormControlled = function({
  field,
  label,
  condition: [truly, falsy],
  onChange
}) {
  const handleChange = (field2) => {
    const value = field2.value === truly ? falsy : truly;
    field2.onChange(value);
    onChange?.(value);
  };
  return /* @__PURE__ */ jsx9(Fragment, { children: /* @__PURE__ */ jsx9(
    Switch,
    {
      checked: field.value === truly,
      onChange: () => handleChange(field),
      label
    }
  ) });
};
function SwitchForm({ control, name, label, condition, onChange }) {
  return /* @__PURE__ */ jsx9(
    Controller9,
    {
      control,
      name,
      render: ({ field }) => /* @__PURE__ */ jsx9(
        SwitchFormControlled,
        {
          field,
          label,
          condition,
          onChange
        }
      )
    }
  );
}

// src/text-area-form/index.tsx
import { TextArea } from "@oppy/omniv2-ui";
import { Controller as Controller10 } from "react-hook-form";
import { jsx as jsx10 } from "react/jsx-runtime";
function TextAreaForm({
  control,
  name,
  placeholder,
  helperText,
  rows,
  maxLength,
  hasEmojiPicker
}) {
  return /* @__PURE__ */ jsx10(
    Controller10,
    {
      control,
      name,
      render: ({
        field: { onChange, onBlur, ref, value },
        fieldState: { error }
      }) => /* @__PURE__ */ jsx10(
        TextArea,
        {
          ref,
          error: error?.message,
          onChange,
          onBlur,
          placeholder,
          helperText: helperText || maxLength ? `${value.length || 0} / ${maxLength}` : "",
          value,
          rows,
          maxLength,
          hasEmojiPicker
        }
      )
    }
  );
}

// src/validations/date-validation/index.ts
import { z } from "zod";
function dateValidation(invalid_type_error) {
  const isoDateRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?Z$/;
  const dateLike = z.union([
    z.string({ invalid_type_error }).refine((str) => isoDateRegex.test(str), { message: invalid_type_error }),
    z.date()
  ]);
  return dateLike.transform(
    (value) => value instanceof Date ? value.toISOString() : value
  );
}

// src/validations/phone-number-validation/index.ts
import parsePhoneNumberFromString from "libphonenumber-js";
import { z as z2 } from "zod";
function phoneNumberValidation(message) {
  return (arg, ctx) => {
    const phone = parsePhoneNumberFromString(arg, {
      defaultCountry: "FR",
      extract: false
    });
    if (phone && phone.isValid()) {
      return phone.number;
    }
    ctx.addIssue({
      code: z2.ZodIssueCode.custom,
      message
    });
    return z2.NEVER;
  };
}
export {
  AutoCompleteForm,
  InputForm as CalendarForm,
  ColorPickerForm,
  FileUploaderForm,
  InputForm2 as InputForm,
  PictureUploaderForm,
  RadioButtonForm,
  SelectForm,
  SwitchForm,
  TextAreaForm,
  dateValidation,
  phoneNumberValidation
};
